/** Unduh PDF dari URL asset (webpack bundle atau static). */
export function downloadPdf(fileUrl, filename = 'materi.pdf') {
  if (!fileUrl) return false;
  const link = document.createElement('a');
  link.href = fileUrl;
  link.download = filename;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  return true;
}

/** Buka PDF di tab baru untuk dicetak. */
export function printPdf(fileUrl) {
  if (!fileUrl) return false;
  const win = window.open(fileUrl, '_blank', 'noopener,noreferrer');
  if (win) {
    win.addEventListener('load', () => {
      try {
        win.print();
      } catch {
        /* popup blocker atau cross-origin */
      }
    });
  }
  return Boolean(win);
}

/** Salin tautan PDF ke clipboard. */
export async function sharePdfLink(fileUrl, title = 'Materi PDF') {
  if (!fileUrl) return false;
  const url = fileUrl.startsWith('http') ? fileUrl : `${window.location.origin}${fileUrl}`;
  try {
    if (navigator.share) {
      await navigator.share({ title, url });
      return true;
    }
    await navigator.clipboard.writeText(url);
    return true;
  } catch {
    return false;
  }
}
